<template>
    <div>
        <h1><!-- <span style="text-transform: uppercase">{{ getType(getActualTest().target) }}</span>--> Test {{ transl["STR_FROM"]}} {{ getActualTest().time | unixtimestamp }}
        <span v-if="getActualTest().cycler">-  {{ transl["STR_TESTING_DEVICE"]}} {{ GetNickname(getActualTest().cycler) }} - {{ getActualTest().cycler }}</span></h1>
        <div class="restable">
            <div class="restatable" v-if="getActualTest().target == 'covid19'">

                <!-- <div style="margin-bottom: 15px" v-if="this.$store.getters.ScreeningPortalEnabled && this.$store.getters.probes.filter(e => e.screeningPortalQueued == true).length == 0">
                    <div style="display: flex">
                        <div style="width: 290px;" class="magic-button" v-on:click="transmitScreening(true)" v-if="!transfer">
                            <b>Verz&ouml;gert</b> ans Screening Portal &uuml;bermitteln
                        </div>
                    </div>
                </div> -->
                <label v-if="curves">Covid19</label>
                <!-- <label v-if="curves">{{getActualTest()}}</label> -->
                <!-- <label>{{this.$store.getters.probes}}</label> -->
                <!-- <label>{{ this.$store.getters.tests.find(e => e.testid == this.$route.params.id) }}</label> -->
                <!-- <label>{{ getActualTest().params }}</label> -->
                <!-- <label>{{ getActualTest().params }}</label><br> -->
                <!-- <label>1111</label> -->
                <!-- <label v-if="pars">{{ pars }}</label> -->
                <table border="0">
                    <thead>
                        <th width="100">{{ transl["STR_POSITION"] }}</th>
                        <th width="150">{{ transl["STR_BARCODE"] }}</th>
                        <th width="100">{{ transl["STR_Control"] }}</th>
                        <th width="100">{{ transl["STR_CTValue"] }}</th>
                        <th width="150">{{ transl["STR_RESULT"] }}</th>
                        <th width="110" v-if="transfer">&Uuml;bertragung</th>
                        <th v-if="curves">ROX</th>
                        <th v-if="curves">CY5</th>
                        <th v-if="curves">CY5 CT</th>
                    </thead>
                    <tbody>
                        <tr v-for="t in this.$store.getters.probes">
                            <td>{{ t.well }}</td>
                            <td>{{ t.barcode }}</td>
                            <!-- <td>{{ t }}</td> -->
                            <td :class="{ 'invalid' : !t.valid }">{{ t.valid ? transl["STR_RES_VALID"] : transl["STR_RES_INVALID"] }}</td>
                            <td style="min-width: 80px;"><span v-if="t.positive">{{ t.ct }}</span><span v-else>-</span></td>
                            <!-- <td :class="{ 'positive' : t.positive && t.valid }">{{ t.positive ? transl["STR_RES_POSITIVE"] : transl["STR_RES_NEGATIVE"] }}</td> -->
                            <td :class="{ 'positive' : t.positive }">{{ t.positive ? transl["STR_RES_POSITIVE"] : transl["STR_RES_NEGATIVE"] }}</td>
                            <td v-if="transfer" align="center">
                                <i v-if="t.transfered" class="fas fa-check-circle"></i>
                                <i v-if="t.transfered == false" class="fas fa-spinner"></i>
                            </td>
                            <td v-if="curves" style="min-width:80px">
                                {{ t.rawROX | round }}
                            </td>
                            <td v-if="curves" style="min-width:80px">
                                {{ t.rawCY5 | round}}
                            </td>
                            <td v-if="curves" style="min-width:80px">
                                {{ t.cy5ct }}
                            </td>
                            <td width="30" v-if="t.expressOrder" style="padding: 0px; background-color: gold;min-width: 30px;" align="center" title="Epxress Auswertung">
                                <b>
                                    <i class="fas fa-star"></i>
                                </b>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="restatable" v-if="getActualTest().target == 'lactose'">
                <!-- <div style="margin-bottom: 15px" v-if="this.$store.getters.ScreeningPortalEnabled && this.$store.getters.probes.filter(e => e.screeningPortalQueued == true).length == 0">
                    <div style="display: flex">
                        <div style="width: 290px;" class="magic-button" v-on:click="transmitScreening(true)" v-if="!transfer">
                            <b>Verz&ouml;gert</b> ans Screening Portal &uuml;bermitteln
                        </div>
                    </div>
                </div> -->
                <label>Laktose</label>
                <!-- <label>{{this.$store.getters.probes}}</label> -->
                <table border="0">
                    <thead>
                        <th width="100">{{ transl["STR_POSITION"] }}</th>
                        <th width="150">{{ transl["STR_BARCODE"] }}</th>
                        <th width="200">{{ transl["STR_GENOTYP"] }}</th>
                        <th width="200">{{ transl["STR_RISK"] }}</th>
                        <th width="100" v-if="curves">{{ transl["STR_CTValue"] }} FAM</th>
                        <th width="100" v-if="curves">{{ transl["STR_CTValue"] }} HEX</th>
                        <th width="110" v-if="transfer">&Uuml;bertragung</th>
                        <th v-if="curves">FAM</th>
                        <th v-if="curves">HEX</th>
                        <!-- <th v-if="curves">CY5 CT</th> -->
                    </thead>
                    <tbody>
                        <tr v-for="t in this.$store.getters.probes">
                            <td>{{ t.well }}</td>
                            <td>{{ t.barcode }}</td>
                            <!-- <td>{{ t.result }}</td> -->
                            <td>{{ calcLactose(t) }}</td>
                            <td>{{ calcLactose2(t) }}</td>
                            <td style="min-width: 100px;" v-if="curves"><span >{{ t.FAMct }}</span></td>
                            <td style="min-width: 100px;" v-if="curves"><span >{{ t.HEXct }}</span></td>
                            <td v-if="transfer" align="center">
                                <i v-if="t.transfered" class="fas fa-check-circle"></i>
                                <i v-if="t.transfered == false" class="fas fa-spinner"></i>
                            </td>
                            <td v-if="curves" style="min-width:80px">
                                {{ t.rawFAM | round }}
                            </td>
                            <td v-if="curves" style="min-width:80px">
                                {{ t.rawHEX | round}}
                            </td>
                            <td width="30" v-if="t.expressOrder" style="padding: 0px; background-color: gold;min-width: 30px;" align="center" title="Epxress Auswertung">
                                <b>
                                    <i class="fas fa-star"></i>
                                </b>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="restatable" v-if="getActualTest().target == 'rsv'">
                <label>RSV</label>
                <!-- <label>{{this.$store.getters.probes}}</label> -->
                <table border="0">
                    <thead>
                        <th width="100">{{ transl["STR_POSITION"] }}</th>
                        <th width="150">{{ transl["STR_BARCODE"] }}</th>
                        <th width="100">{{ transl["STR_Control"] }}</th>
                        <th width="100">{{ transl["STR_CTValue"] }}</th>
                        <th width="150">{{ transl["STR_RESULT"] }}</th>
                        <th width="110" v-if="transfer">&Uuml;bertragung</th>
                        <th v-if="curves">ROX</th>
                        <th v-if="curves">CY5</th>
                        <th v-if="curves">CY5 CT</th>
                    </thead>
                    <tbody>
                        <tr v-for="t in this.$store.getters.probes">
                            <td>{{ t.well }}</td>
                            <td>{{ t.barcode }}</td>
                            <!-- <td>{{ t }}</td> -->
                            <td :class="{ 'invalid' : !t.valid }">{{ t.valid ? transl["STR_RES_VALID"] : transl["STR_RES_INVALID"] }}</td>
                            <td style="min-width: 80px;"><span v-if="t.positive">{{ t.ct }}</span><span v-else>-</span></td>
                            <td :class="{ 'positive' : t.positive && t.valid }">{{ t.positive ? transl["STR_RES_POSITIVE"] : transl["STR_RES_NEGATIVE"] }}</td>
                            <td v-if="transfer" align="center">
                                <i v-if="t.transfered" class="fas fa-check-circle"></i>
                                <i v-if="t.transfered == false" class="fas fa-spinner"></i>
                            </td>
                            <td v-if="curves" style="min-width:80px">
                                {{ t.rawROX | round }}
                            </td>
                            <td v-if="curves" style="min-width:80px">
                                {{ t.rawCY5 | round}}
                            </td>
                            <td v-if="curves" style="min-width:80px">
                                {{ t.cy5ct }}
                            </td>
                            <td width="30" v-if="t.expressOrder" style="padding: 0px; background-color: gold;min-width: 30px;" align="center" title="Epxress Auswertung">
                                <b>
                                    <i class="fas fa-star"></i>
                                </b>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="restatable" v-if="getActualTest().target == 'influenzaab'">
                <label>Influenza A/B</label>
                <!-- <label v-if="curves">{{this.$store.getters.probes}}</label> -->
                <table border="0">
                    <thead>
                        <th width="100">{{ transl["STR_POSITION"] }}</th>
                        <th width="150">{{ transl["STR_BARCODE"] }}</th>
                        <!-- <th width="100">{{ transl["STR_CTValue"] }}</th> -->
                        <th width="100">{{ transl["STR_Control"] }}</th>
                        <!-- <th width="150">{{ transl["STR_RESULT"] }}</th> -->
                        <th width="110" v-if="transfer">&Uuml;bertragung</th>
                        <!-- <th v-if="curves">Test E</th> -->
                        <th>A - CT Wert</th>
                        <th>Ergebnis A</th>
                        <th>B - CT Wert</th>
                        <th>Ergebnis B</th>
                        <th v-if="curves">FAM</th>
                        <th v-if="curves">HEX</th>
                        <th v-if="curves">CY5</th>
                        <th v-if="curves">CY5 CT</th>
                    </thead>
                    <tbody>
                        <tr v-for="t in this.$store.getters.probes">
                            <td>{{ t.well }}</td>
                            <td>{{ t.barcode }}</td>
                            <!-- <td>{{ t }}</td> -->
                            <!-- <td style="min-width: 80px;"><span v-if="t.positive">{{ t.ct }}</span><span v-else>-</span></td> -->
                            <td :class="{ 'invalid' : !t.valid }">{{ t.valid ? transl["STR_RES_VALID"] : transl["STR_RES_INVALID"] }}</td>
                            <!-- <td :class="{ 'positive' : t.positive && t.valid }">{{ t.positive ? transl["STR_RES_POSITIVE"] : transl["STR_RES_NEGATIVE"] }}</td>
                            <td v-if="transfer" align="center">
                                <i v-if="t.transfered" class="fas fa-check-circle"></i>
                                <i v-if="t.transfered == false" class="fas fa-spinner"></i>
                            </td> -->
                            <td style="min-width:80px">
                                {{ t.FAMct }}
                            </td>
                            <!-- <td v-if="curves" style="min-width:80px">
                                {{ t.rawFAM | round }}
                            </td> -->
                            <td :class="{ 'positive' : t.positiveFAM && t.valid }">{{ t.positiveFAM ? transl["STR_RES_POSITIVE"] : transl["STR_RES_NEGATIVE"] }}</td>
                            <td style="min-width:80px">
                                {{ t.HEXct }}
                            </td>
                            <td :class="{ 'positive' : t.positiveHEX && t.valid }">{{ t.positiveHEX ? transl["STR_RES_POSITIVE"] : transl["STR_RES_NEGATIVE"] }}</td>
                            <!-- <td v-if="curves" style="min-width:80px">
                                {{ t.rawHEX | round}}
                            </td> -->
                            <td v-if="curves" style="min-width:80px">
                                {{ t.rawFAM | round}}
                            </td>
                            <td v-if="curves" style="min-width:80px">
                                {{ t.rawHEX | round}}
                            </td>
                            <td v-if="curves" style="min-width:80px">
                                {{ t.rawCY5 | round}}
                            </td>
                            <td v-if="curves" style="min-width:80px">
                                {{ t.cy5ct }}
                            </td>
                            <td width="30" v-if="t.expressOrder" style="padding: 0px; background-color: gold;min-width: 30px;" align="center" title="Express Auswertung">
                                <b>
                                    <i class="fas fa-star"></i>
                                </b>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="restatable" v-if="getActualTest().target == 'cofluenza'">
                <label>Winterplex</label>
                <!-- <label v-if="curves">{{this.$store.getters.probes}}</label> -->
                <table border="0">
                    <thead>
                        <th width="100">{{ transl["STR_POSITION"] }}</th>
                        <th width="150">{{ transl["STR_BARCODE"] }}</th>
                        <th width="100">{{ transl["STR_Control"] }}</th>
                        <th>Ergebnis SC2</th>
                        <th>Ergebnis Infl</th>
                        <th>Ergebnis RSV</th>
                        <th v-if="curves">FAM</th>
                        <th v-if="curves">HEX</th>
                        <th v-if="curves">ROX</th>
                        <th v-if="curves">CY5</th>
                        <th v-if="curves">CT CY5</th>
                    </thead>
                    <tbody>
                        <tr v-for="t in this.$store.getters.probes">
                            <td>{{ t.well }}</td>
                            <td>{{ t.barcode }}</td>
                            <td :class="{ 'invalid' : !t.valid }">{{ t.valid ? transl["STR_RES_VALID"] : transl["STR_RES_INVALID"] }}</td>
                            <td :class="{ 'positive' : t.positiveFAM && t.valid }">{{ t.positiveFAM ? transl["STR_RES_POSITIVE"] : transl["STR_RES_NEGATIVE"] }}<br>
                                <p v-if="t.positiveFAM">{{ t.FAMct }}</p>
                            </td>
                            <td :class="{ 'positive' : t.positiveHEX && t.valid }">{{ t.positiveHEX ? transl["STR_RES_POSITIVE"] : transl["STR_RES_NEGATIVE"] }}<br>
                                <p v-if="t.positiveHEX">{{ t.HEXct }}</p>
                            </td>
                            <td :class="{ 'positive' : t.positiveROX && t.valid }">{{ t.positiveROX ? transl["STR_RES_POSITIVE"] : transl["STR_RES_NEGATIVE"] }}<br>
                                <p v-if="t.positiveROX">{{ t.ROXct }}</p>
                            </td>
                            <td v-if="curves" style="min-width:80px">
                                {{ t.rawFAM | round}}
                            </td>
                            <td v-if="curves" style="min-width:80px">
                                {{ t.rawHEX | round}}
                            </td>
                            <td v-if="curves" style="min-width:80px">
                                {{ t.rawROX | round}}
                            </td>
                            <td v-if="curves" style="min-width:80px">
                                {{ t.rawCY5 | round}}
                            </td>
                            <td v-if="curves" style="min-width:80px">
                                {{ t.cy5ct }}
                            </td>
                            <td width="30" v-if="t.expressOrder" style="padding: 0px; background-color: gold;min-width: 30px;" align="center" title="Express Auswertung">
                                <b>
                                    <i class="fas fa-star"></i>
                                </b>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="restatable" v-if="getActualTest().target == 'gluten'">
                <label>Gluten</label>
                <!-- <label>{{this.$store.getters.probes}}</label> -->
                <table border="0">
                    <thead>
                        <th width="100">{{ transl["STR_POSITION"] }}</th>
                        <th width="150">{{ transl["STR_BARCODE"] }}</th>
                        <th width="200">{{ transl["STR_GENOTYP"] }}</th>
                        <th width="200">{{ transl["STR_RISK"] }}</th>
                        <th width="100" v-if="curves">{{ transl["STR_CTValue"] }} FAM</th>
                        <th width="100" v-if="curves">{{ transl["STR_CTValue"] }} HEX</th>
                        <th width="110" v-if="transfer">&Uuml;bertragung</th>
                        <th v-if="curves">FAM</th>
                        <th v-if="curves">HEX</th>
                        <!-- <th v-if="curves">CY5 CT</th> -->
                    </thead>
                    <tbody>
                        <tr v-for="t in this.$store.getters.probes">
                            <td>{{ t.well }}</td>
                            <td>{{ t.barcode }}</td>
                            <!-- <td>{{ t.result }}</td> -->
                            <td>{{ calcGluten(t) }}</td>
                            <td>{{ calcGluten2(t) }}</td>
                            <td style="min-width: 100px;" v-if="curves"><span >{{ t.FAMct }}</span></td>
                            <td style="min-width: 100px;" v-if="curves"><span >{{ t.HEXct }}</span></td>
                            <td v-if="transfer" align="center">
                                <i v-if="t.transfered" class="fas fa-check-circle"></i>
                                <i v-if="t.transfered == false" class="fas fa-spinner"></i>
                            </td>
                            <td v-if="curves" style="min-width:80px">
                                {{ t.rawFAM | round }}
                            </td>
                            <td v-if="curves" style="min-width:80px">
                                {{ t.rawHEX | round}}
                            </td>
                            <td width="30" v-if="t.expressOrder" style="padding: 0px; background-color: gold;min-width: 30px;" align="center" title="Epxress Auswertung">
                                <b>
                                    <i class="fas fa-star"></i>
                                </b>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="restatable" v-if="getActualTest().target == 'fructose'">
                <label>Gluten</label>
                <!-- <label>{{this.$store.getters.probes}}</label> -->
                <table border="0">
                    <thead>
                        <th width="100">{{ transl["STR_POSITION"] }}</th>
                        <th width="150">{{ transl["STR_BARCODE"] }}</th>
                        <th width="200">{{ transl["STR_GENOTYP"] }}</th>
                        <th width="200">{{ transl["STR_RISK"] }}</th>
                        <th width="100" v-if="curves">{{ transl["STR_CTValue"] }} FAM</th>
                        <th width="100" v-if="curves">{{ transl["STR_CTValue"] }} HEX</th>
                        <th width="110" v-if="transfer">&Uuml;bertragung</th>
                        <th v-if="curves">FAM</th>
                        <th v-if="curves">HEX</th>
                        <!-- <th v-if="curves">CY5 CT</th> -->
                    </thead>
                    <tbody>
                        <tr v-for="t in this.$store.getters.probes">
                            <td>{{ t.well }}</td>
                            <td>{{ t.barcode }}</td>
                            <!-- <td>{{ t.result }}</td> -->
                            <td>{{ calcGluten(t) }}</td>
                            <td>{{ calcGluten2(t) }}</td>
                            <td style="min-width: 100px;" v-if="curves"><span >{{ t.FAMct }}</span></td>
                            <td style="min-width: 100px;" v-if="curves"><span >{{ t.HEXct }}</span></td>
                            <td v-if="transfer" align="center">
                                <i v-if="t.transfered" class="fas fa-check-circle"></i>
                                <i v-if="t.transfered == false" class="fas fa-spinner"></i>
                            </td>
                            <td v-if="curves" style="min-width:80px">
                                {{ t.rawFAM | round }}
                            </td>
                            <td v-if="curves" style="min-width:80px">
                                {{ t.rawHEX | round}}
                            </td>
                            <td width="30" v-if="t.expressOrder" style="padding: 0px; background-color: gold;min-width: 30px;" align="center" title="Epxress Auswertung">
                                <b>
                                    <i class="fas fa-star"></i>
                                </b>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="restatable" v-if="getActualTest().target == 'bonefitness'">
                <label>Gluten</label>
                <!-- <label>{{this.$store.getters.probes}}</label> -->
                <table border="0">
                    <thead>
                        <th width="100">{{ transl["STR_POSITION"] }}</th>
                        <th width="150">{{ transl["STR_BARCODE"] }}</th>
                        <th width="200">{{ transl["STR_GENOTYP_VITAMIND"] }}</th>
                        <th width="200">{{ transl["STR_RISK_VITAMIND"] }}</th>
                        <th width="200">{{ transl["STR_GENOTYP_KOLLAGEN"] }}</th>
                        <th width="200">{{ transl["STR_RISK_KOLLAGEN"] }}</th>
                        <th v-if="curves">FAM</th>
                        <th v-if="curves">HEX</th>
                        <!-- <th v-if="curves">CY5 CT</th> -->
                    </thead>
                    <tbody>
                        <tr v-for="t in this.$store.getters.probes">
                            <td>{{ t.well }}</td>
                            <td>{{ t.barcode }}</td>
                            <!-- <td>{{ t.result }}</td> -->
                            <!-- <td>{{ calcGluten(t) }}</td>
                            <td>{{ calcGluten2(t) }}</td>
                            <td style="min-width: 100px;" v-if="curves"><span >{{ t.FAMct }}</span></td>
                            <td style="min-width: 100px;" v-if="curves"><span >{{ t.HEXct }}</span></td>
                            <td v-if="transfer" align="center">
                                <i v-if="t.transfered" class="fas fa-check-circle"></i>
                                <i v-if="t.transfered == false" class="fas fa-spinner"></i>
                            </td>
                            <td v-if="curves" style="min-width:80px">
                                {{ t.rawFAM | round }}
                            </td>
                            <td v-if="curves" style="min-width:80px">
                                {{ t.rawHEX | round}}
                            </td>
                            <td width="30" v-if="t.expressOrder" style="padding: 0px; background-color: gold;min-width: 30px;" align="center" title="Epxress Auswertung">
                                <b>
                                    <i class="fas fa-star"></i>
                                </b>
                            </td> -->
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="resgraph" v-if="curves">
                <!-- <p>{{series}}</p> -->
                <apexchart v-if="series.length > 0" width="800px" height="400px" type="line" :options="options" :series="series"></apexchart>
            </div>
        </div>
    </div>
</template>
<script>
export default({
    props: [ 'test', 'curves', 'admin', 'transl' ],
    filters: {
        round(a) {
            return Math.round(a).toFixed(1);
        },
        unixtimestamp(UNIX_timestamp) {
            var a = new Date(UNIX_timestamp * 1000);
            var year = a.getFullYear();
            var month = a.getMonth()+1;
            var date = a.getDate();
            var hour = a.getHours();
            var min = a.getMinutes();
            var sec = a.getSeconds();
            if(sec < 10) sec="0"+sec;

            if(date < 10) date="0"+date;
            if(month < 10) month="0"+month;
            if(hour < 10) hour="0"+hour;
            if(min < 10) min="0"+min;
            

            var time = date + '.' + month + '.' + year + ' ' + hour + ':' + min + ':' + sec ;
            return time;            
        }
    },
    data() {
        return {
            roxfilter: 1,
            transmit: [],
            transfer: false,
            ScreeningPortal: false,
            nicks: [],
            options: {
                annotations: {
                    yaxis: [
                        {
                        y: 1000,
                        borderColor: '#FF0000',
                        opacity: 1,
                        label: {
                            borderColor: '#FF0000',
                            style: {
                            color: '#fff',
                            background: '#FF0000'
                            },
                            text: 'Covid19 Positiv (ROX)'
                        },
                        },
                    ]
                },
                legend: {
                    show: true,
                },
                stroke: {
                    width: 1,
                    curve: 'smooth',
                },
                chart: {               
                toolbar: {
                    show: false,
                },                    
                    id: 'chart0'
                },
                yaxis: {
                    tickAmount: 7,
                    labels: {
    formatter: function(value) {
      var val = Math.abs(value)
    //   if (val >= 1000) {
    //     val = (val / 1000).toFixed(0) + ' K'
    //   }
      return val
    }
  }
                },
            },            
            series: [],
            pars: "peter",
            actualTest: [],
        }
    },
    mounted() {
        //console.log("rf: ", this.roxfilter)
        this.options.annotations.yaxis[0].y = this.roxfilter = 300;
        //this.options.annotations.yaxis[0].label.text = "COVID19 Positive";
        this.options.annotations.yaxis[0].label.text = "Positive";

        //this.ScreeningPortal = this.$store.getters.ScreeningPortalEnabled;
        this.loadNicks();

        //this.actualTest = this.$store.getters.tests.find(e => e.testid == this.$route.params.id);
        this.actualTest = this.getActualTest();
        this.pars = "hugo";
        if(this.curves) {
            this.options.annotations.yaxis[0].label.text = "";
            switch(this.actualTest.target) {
                case "covid19":
                this.options.annotations.yaxis[0].y = this.roxfilter = 300; // TODO: sollte aus Params kommen
                //this.options.annotations.yaxis[0].label.text = "";
                    //this.pars = JSON.parse(this.actualTest.params);
                    //this.pars = "test";
                    //this.actualTest
                    break;
                case "lactose":
                    this.options.annotations = undefined;
                    //this.options.annotations.yaxis[0].y = this.roxfilter = 0;   // checken
                    //this.options.annotations.yaxis[0].label.text = "";
                    break;
                case "rsv":
                    this.options.annotations.yaxis[0].y = this.roxfilter = 300; // TODO: sollte aus Params kommen
                    //this.options.annotations.yaxis[0].label.text = "";
                    break;
                case "influenzaab":
                    this.options.annotations.yaxis[0].y = this.roxfilter = 300; // TODO: sollte aus Params kommen
                    //this.options.annotations.yaxis[0].label.text = "";
                    break;
                case "cofluenza":
                    this.options.annotations.yaxis[0].y = this.roxfilter = 300; // TODO: sollte aus Params kommen
                    //this.options.annotations.yaxis[0].label.text = "";
                    break;
                case "gluten":
                    //this.options.annotations.yaxis[0].y = this.roxfilter = 300;
                    //this.options.annotations.yaxis[0].label.text = "Gluten Positiv (ROX)";
                    break;
                case "fructose":
                    //this.options.annotations.yaxis[0].y = this.roxfilter = 300;
                    //this.options.annotations.yaxis[0].label.text = "Gluten Positiv (ROX)";
                    break;
                case "bonefitness":
                    this.options.annotations.yaxis[0].y = this.roxfilter = 300;
                    //this.options.annotations.yaxis[0].label.text = "Gluten Positiv (ROX)";
                    break;
                default:
                    break;
            }

            // this.pars = "xxx";
            this.$store.dispatch("LoadTest", this.$route.params.id)
            .then((r) => {
             this.pars = r;
                r.filter(e => e.wellTarget=="ROX").forEach((rox) => {
                    var vxp = [];
                    rox.wellDataAmp.split(",").forEach((cc) => {
                        vxp.push(parseFloat(cc))
                    })
                    this.series.push({
                        name: rox.wellBarcode,
                        data: vxp,
                    })
                });
                r.filter(e => e.wellTarget=="FAM").forEach((fam) => {
                    var vxp = [];
                    fam.wellDataAmp.split(",").forEach((cc) => {
                        vxp.push(parseFloat(cc))
                    })
                    this.series.push({
                        name: "FAM"+fam.wellBarcode,
                        data: vxp,
                    })
                });
                r.filter(e => e.wellTarget=="HEX").forEach((hex) => {
                    var vxp = [];
                    hex.wellDataAmp.split(",").forEach((cc) => {
                        vxp.push(parseFloat(cc))
                    })
                    this.series.push({
                        name: "HEX"+hex.wellBarcode,
                        data: vxp,
                    })
                });
            });
        }      
    },
    methods: {
        GetNickname(serial) {
            var nn = this.$store.getters.cyclers.find(e => e.serial == serial);
            if(nn && nn.name) { return nn.name; } else { return serial; }
        }, 
        getActualTest() {
            return this.$store.getters.tests.find(e => e.testid == this.$route.params.id);
        },
        getType(type) {
            return type=="lactose"?"Laktose":type;
        },       
        loadNicks() {
            this.nicks = [];
            this.$store.getters.cyclers.forEach((c) => {
                var nickname = localStorage.getItem(c.serial);
                if(nickname) {
                    this.nicks.push({
                        serial: c.serial,
                        nick: nickname,
                    })
                }
            })
        },
        nickname(serial) {
            var find = this.nicks.find(e => e.serial == serial);
            if(find) {
                return find.nick;
            } else {
                return serial;
            }
        },
        calcLactose (well) {
            if ((well.FAMct == 0 || well.FAMct > 35) && (well.HEXct == 0 || well.HEXct > 35)) // korrigiert??
            {
                return "nicht auswertbar"; 
            }
            else
            {
                // new assigned for better readability
                let allele1_flour = well.rawFAM;
                let allele2_flour = well.rawHEX;
                if (allele1_flour <= 1.0 && allele2_flour > 600.0)
                {
                    return "T/T";
                }
                else if (allele1_flour > 1.0 && allele2_flour > 1.0 && allele2_flour > allele1_flour)
                {
                    return "C/T";
                }
                else if (allele1_flour > 1.0 && allele2_flour < allele1_flour)
                {
                    return "C/C";
                }
                return well; //allele1_flour + "  " + allele2_flour;
            }
           
        },
        calcLactose2 (well) {
            if ((well.FAMct == 0 || well.FAMct > 35) && (well.HEXct == 0 || well.HEXct > 35)) // korrigiert??
            {
                return "nicht auswertbar"; 
            }
            else
            {
                // new assigned for better readability
                let allele1_flour = well.rawFAM;
                let allele2_flour = well.rawHEX;
                if (allele1_flour <= 1.0 && allele2_flour > 600.0)
                {
                    return "kein erhöhtes Risiko";
                }
                else if (allele1_flour > 1.0 && allele2_flour > 1.0 && allele2_flour > allele1_flour)
                {
                    return "leicht erhöhtes Risiko";
                }
                else if (allele1_flour > 1.0 && allele2_flour < allele1_flour)
                {
                    return "stark erhöhtes Risiko";
                }
                return well; //allele1_flour + "  " + allele2_flour;
            }
           
        },
        calcGluten (well) {
            if ((well.FAMct == 0 || well.FAMct > 35) && (well.HEXct == 0 || well.HEXct > 35)) // korrigiert??
            {
                return "nicht auswertbar"; 
            }
            else
            {
                // new assigned for better readability
                let allele1_flour = well.rawFAM;
                let allele2_flour = well.rawHEX;
                if (allele1_flour <= 1.0 && allele2_flour > 600.0)
                {
                    return "T/T";
                }
                else if (allele1_flour > 1.0 && allele2_flour > 1.0 && allele2_flour > allele1_flour)
                {
                    return "C/T";
                }
                else if (allele1_flour > 1.0 && allele2_flour < allele1_flour)
                {
                    return "C/C";
                }
                return well; //allele1_flour + "  " + allele2_flour;
            }
           
        },
        calcGluten2 (well) {
            if ((well.FAMct == 0 || well.FAMct > 35) && (well.HEXct == 0 || well.HEXct > 35)) // korrigiert??
            {
                return "nicht auswertbar"; 
            }
            else
            {
                // new assigned for better readability
                let allele1_flour = well.rawFAM;
                let allele2_flour = well.rawHEX;
                if (allele1_flour <= 1.0 && allele2_flour > 600.0)
                {
                    return "kein erhöhtes Risiko";
                }
                else if (allele1_flour > 1.0 && allele2_flour > 1.0 && allele2_flour > allele1_flour)
                {
                    return "leicht erhöhtes Risiko";
                }
                else if (allele1_flour > 1.0 && allele2_flour < allele1_flour)
                {
                    return "stark erhöhtes Risiko";
                }
                return well; //allele1_flour + "  " + allele2_flour;
            }
           
        },                       
        // transmitScreening(delay) {
        //     var testId = this.$route.params.id;
        //     if(confirm("Möchten Sie die Ergebnisse automatisch an das Screening Portal übermitteln? Es werden nur negativ+gültige Ergebnisse übermittelt.")) {
        //         this.$store.dispatch("sendScreeningPortal", {
        //             probes: this.$store.getters.probes.filter(e => e.positive == false && e.valid == true),
        //             delay: delay,
        //         })
        //     }
        // },        
    }
})
</script>

<style>
.restable {
    display: flex;
}
.restatable {
    width: 800px;
}
.resgraph {
    height: 100%;
    width: 800px;
    margin: auto;
}
</style>